import { ChangeEvent, FC, useCallback } from 'react';

import type { ColumnProps } from './model';

interface ListFieldColumnProps extends ColumnProps<Nullable<string>> {
  availableItems: readonly any[];
}

export const GridListColumn: FC<ListFieldColumnProps> = ({ value, availableItems, id, setCellValue }) => {
  const onchange = useCallback(
    (e: ChangeEvent<HTMLSelectElement>) => {
      setCellValue(id, e.target.value);
    },
    [id, setCellValue],
  );
  return (
    <select
      className="form-select"
      data-e2e={id + '-item-select'}
      onChange={onchange}
      style={{ minWidth: '80px' }}
      value={value || '?'}
    >
      {availableItems.map(item => (
        <option key={item.value} value={item.value}>
          {item.label}
        </option>
      ))}
    </select>
  );
};

GridListColumn.displayName = 'GridListColumn';
